<template>
  <div>
    <Header />
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="10" offset="1">
            <v-card class="pa-4" width="100%" text>
              <CardTitle class="justify-center display-3" :title="translate.title" />

              <!-- Presentation  -->
              <CardTitle :title="translate.presentation.title" class="display-1" />
              <CardTitle :title="translate.presentation.subtitle" class="title" />
              <CardText :text="translate.presentation.text1" />
              <CardText :text="translate.presentation.text2" />

              <!-- Préambule -->
              <CardTitle :title="translate.preamble.title" class="display-1" />
              <CardTitle :title="translate.preamble.subtitle" class="title" />
              <CardText :text="translate.preamble.text" />

              <!-- Information Légales -->
              <CardTitle :title="translate.legalInformation.title" class="display-1" />
              <CardTitle :title="translate.legalInformation.subtitle" class="title" />
              <CardText :text="translate.legalInformation.text" />

              <!-- Définition -->
              <CardTitle :title="translate.definition.title" class="display-1" />
              <CardTitle :title="translate.definition.subtitle" class="title" />
              <CardTitle :title="translate.definition.section1.title" class="subtitle-1 pb-0" />
              <CardText :text="translate.definition.section1.text" />
              <CardTitle :title="translate.definition.section2.title" class="subtitle-1 pb-0" />
              <CardText :text="translate.definition.section2.text" />
              <CardTitle :title="translate.definition.section3.title" class="subtitle-1 pb-0" />
              <CardText :text="translate.definition.section3.text" />
              <CardTitle :title="translate.definition.section4.title" class="subtitle-1 pb-0" />
              <CardText :text="translate.definition.section4.text" />

              <!-- Accès au services -->
              <CardTitle :title="translate.accessService.title" class="display-1" />
              <CardTitle :title="translate.accessService.subtitle" class="title" />
              <CardText :text="translate.accessService.text" />

              <!-- Propriété intellectuelle -->
              <CardTitle :title="translate.intellectualProperty.title" class="display-1" />
              <CardTitle :title="translate.intellectualProperty.subtitle" class="title" />
              <CardText :text="translate.intellectualProperty.text" />

              <!-- Durée et résiliation -->
              <CardTitle :title="translate.termAndTermination.title" class="display-1" />
              <CardTitle :title="translate.termAndTermination.subtitle" class="title" />
              <CardText :text="translate.termAndTermination.text" />

              <!-- Responsabilités -->
              <CardTitle :title="translate.responsibilities.title" class="display-1" />
              <CardTitle :title="translate.responsibilities.subtitle" class="title" />
              <CardText :text="translate.responsibilities.text" />

              <!-- Configuration technique minimale requise -->
              <CardTitle :title="translate.setup.title" class="display-1" />
              <CardTitle :title="translate.setup.subtitle" class="title" />
              <CardText :text="translate.setup.text" />

              <!-- Modifications des conditions d’utilisation -->
              <CardTitle :title="translate.termOfUse.title" class="display-1" />
              <CardTitle :title="translate.termOfUse.subtitle" class="title" />
              <CardText :text="translate.termOfUse.text" />

              <!-- Conditions générales de vente -->
              <CardTitle :title="translate.termOfSale.title" class="display-1" />
              <CardTitle :title="translate.termOfSale.subtitle" class="title" />
              <CardText :text="translate.termOfSale.text" />

              <!-- Droit applicable -->
              <CardTitle :title="translate.applicableLaw.title" class="display-1" />
              <CardText :text="translate.applicableLaw.text" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer />
  </div>
</template>

<script>
import CardTitle from '@/components/CardTitle'
import CardText from '@/components/CardText'

export default {
  name: 'TermsOfService',
  components: {
    CardTitle,
    CardText
  },
  computed: {
    translate() {
      return this.$t('termsOfService')
    }
  }
}
</script>
